import {fromJS, Map} from 'immutable';
import configActions from '../../actions/config.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {ConfigState} from './types';

const initialState: ConfigState = {
    locale: null,
    isRTL: false,
    epicFooter: {},
    isFortniteGamesOnboarded: false,
    isDisableTimeRangeWarning: false,
    useEpicHeader: false,
    MAXIMUM_INIT_APP_COUNT: null,
    MINIMUM_OLD_IN_MONTH: null,
    socialChannelsProperties: {},
    disableSocials: {},
    migrationDueDate: null, // deprecated
    talonFlowID: null,
    enableTalon: false,
    enableMaintenance: false,
    enableEarnings: false,
    enableV2Signup: false,
    enableV2Migration: false,
    enableNews: false,
    enableFnGames: false,
    enableFnPerformanceTab: false,
    enableFnPerformanceZeroLimit: false,
    enableFnPlayrateTab: false,
    enableFnRewardsTab: false,
    enableCodeSelfService: false,
    enableReactivation: false,
    quickLinks: {},
    // migrate to quicklinks in CMS?
    accountManagementUrl: null,
    hyperWalletHomepage: null,
    hyperwalletContactPage: null,
    boaHomePage: null,
    baseStoreUrl: null
};

export const DEFAULT_STATE = fromJS(initialState);

export const configReducer = (state: Map<keyof ConfigState, any> = DEFAULT_STATE, action) => {
    let newState = state;

    switch (action.type) {
        case configActions.TYPES.GET_APP_CONFIG:
            newState = newState.updateIn(['loading'], () => true);
            return newState;

        case configActions.TYPES.GET_APP_CONFIG_COMPLETE:
            newState = fromJS(action.payload);
            return newState;

        default:
            return newState;
    }
};

export default dieselReducer('config', configReducer);
